import { isDefined } from "@clipboard-health/util-ts";
import { isWithinInterval, subDays } from "date-fns";

import { VisitStatuses } from "./constants";
import { type VisitWithCaseData } from "./types";
import { useVisitsListData } from "./useVisitsListData";
import { getHighlightedVisitActionDeadlineTime } from "./utils";

// We want to highlight a visit that is within 1 day of the action deadline
// And the visit has been confirmed
function isHighlightedVisit(visit: VisitWithCaseData) {
  const endOfInterval = getHighlightedVisitActionDeadlineTime(visit);
  if (!isDefined(endOfInterval)) {
    return false;
  }

  const now = new Date();

  const interval = {
    start: subDays(endOfInterval, 1),
    end: endOfInterval,
  };

  return visit.attributes.status === VisitStatuses.CONFIRMED && isWithinInterval(now, interval);
}

export function useWorkerBookedVisitsData() {
  const {
    visits,
    caseIdToPatientMap,
    caseIdToSpecialtiesMap,
    caseIdToWorkplaceNameMap,
    isVisitsLoading,
  } = useVisitsListData({ booked: "true" });

  const highlightedVisits = visits.filter((visit) => isHighlightedVisit(visit));
  const regularVisits = visits.filter((visit) => !isHighlightedVisit(visit));

  return {
    regularVisits,
    highlightedVisits,
    caseIdToPatientMap,
    caseIdToSpecialtiesMap,
    caseIdToWorkplaceNameMap,
    isVisitsLoading,
  };
}
